import { render, staticRenderFns } from "./XMenu.vue?vue&type=template&id=6e3001a1&scoped=true&"
import script from "./XMenu.vue?vue&type=script&lang=js&"
export * from "./XMenu.vue?vue&type=script&lang=js&"
import style0 from "./XMenu.vue?vue&type=style&index=0&id=6e3001a1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e3001a1",
  null
  
)

export default component.exports